
import { createSlice } from '@reduxjs/toolkit'

export const contractData = createSlice({
  name: 'contract',
  initialState: {
    nftContract: "",
    isSaleEnabled:0,
  },
  reducers: {
    setNFTContract: (state,action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.nftContract= action.payload;
    },
    setContractStatus:(state,action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.isSaleEnabled= action.payload.isSaleEnabled
    },
    
   
  },
})

// Action creators are generated for each case reducer function
export const { setNFTContract,setContractStatus } = contractData.actions

export default contractData.reducer